import { Component, OnInit } from '@angular/core';

import {
    CommonComponent,
    CommonElementsConfig,
} from '../common/common.component';

@Component({
    selector: 'app-dialog-ledger-deposit',
    templateUrl: '../common/common.component.html',
    styleUrls: ['../common/common.component.css'],
})
export class DepositComponent extends CommonComponent implements OnInit {
    public override elements = new CommonElementsConfig(['amount', 'comment']);

    public override submitLabel = 'Deposit';
    public override headingLabel = 'Deposit to';

    public override submit() {
        let payload = {
            amount: Number(this.formGroup.get('amount')!.value),
            comment: this.formGroup.get('comment')!.value,
            receiver_email: this.tgtOpenIdProfile!.email,
        };

        this.sendPayload('ledger/deposit', payload);
    }
}
